import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import cn from 'classnames'

import useNavigationProfile from '../ProfileNav/useNavigationProfile'
import { profilePaths } from '../../constants/constans'

import styles from './styles.module.scss'

// Mobile bottom navigation for profile area
// - shows on small screens only (see styles.module.scss)
// - respects iOS safe-area via env(safe-area-inset-bottom)
// - uses the same navigation source as ProfileNav to keep icons/titles consistent
const MobileBottomBar = ({ isVisible = true }) => {
  const { navigation } = useNavigationProfile()
  const location = useLocation()

  // Order of items in the bottom bar
  const orderedKeys = [
    profilePaths.vacancies,
    profilePaths.general,
    profilePaths.billing_services, // may be absent when billing disabled
    profilePaths.chat,
    profilePaths.settings,
  ]

  // Keep only items that exist in navigation
  const items = orderedKeys
    .filter((k) => navigation[k])
    .map((k) => ({ path: k, ...navigation[k] }))

  const isActiveByPaths = (paths) => {
    return (match, loc) => paths.includes(loc.pathname)
  }

  return (
    <nav className={cn(styles.bar, { [styles.hidden]: !isVisible })} aria-label='Mobile bottom navigation'>
      <ul className={cn(styles.menu, 'profile-container')}
        role='menubar'
      >
        {items.map(({ path, icon, title, paths }) => (
          <li key={path} className={styles.item} role='none'>
            <NavLink
              to={path}
              className={styles.link}
              activeClassName={styles.active}
              isActive={paths ? isActiveByPaths(paths) : undefined}
              role='menuitem'
              aria-current={paths && paths.includes(location.pathname) ? 'page' : undefined}
            >
              <span className={styles.icon}>{icon}</span>
              <span className={styles.label}>{title}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default MobileBottomBar
